module.exports = __webpack_public_path__ + "79d9da7ab937aa298c05f5458cec828d.svg";